module.exports = __webpack_public_path__ + "static/media/connector-line_curve.4dbbc431.svg";